import React, { useEffect, useState } from "react"
import Table, {
  recordsPerPageOptions,
} from "../../../../../components/v2/table/table"
import styled from "@emotion/styled/macro"
import { colors } from "../../../../../library/constants/styles/colors"
import {
  clearTeacherKnowmapKnowmixKnowmeets,
  getTeacherKnowmapKnowmixKnowmeets,
} from "../../../../../library/store/actions/creators/knowmapCreators"
import { useDispatch, useSelector } from "react-redux"
import KnowmeetModalsProvider, {
  useKnowmeetModals,
} from "../../../../../hooks/entities/useKnowmeetModals"
import * as qs from "query-string"
import { Route, useHistory, useLocation, useRouteMatch } from "react-router-dom"
import { useAlert } from "../../../../../hooks/useAlert"
import { SearchOutlined } from "@material-ui/icons"
import {
  KNOWMAP_INCOMING_KNOWMEET,
  KNOWMAP_UKNOW_KNOWMIX,
} from "../../../../../library/constants/routes"
import { TablePagination, Tooltip } from "@material-ui/core"
import { key } from "../../../../../library/utils/generateKey"
import EditOutlined from "@material-ui/icons/EditOutlined"
import DeleteForeverOutlined from "@material-ui/icons/DeleteForeverOutlined"
import composeQuery from "../../../../../library/utils/composeQuery"
import withErrorBoundary from "../../../../../hocs/guards/withErrorBoundary"
import UknowDialog from "../../../knowmix/knowmixSingle/knowmixSettings/knowmixSettingsKnowmeets/uknowDialog/uknowDialog"

const columns = [
  {
    id: 1,
    label: "Name",
  },
  // {
  //   id: 2,
  //   label: "Date created",
  // },
  {
    id: 3,
    label: "Target date/time",
  },
  {
    id: 4,
    label: "Cohort/Arrivals",
  },
  {
    id: 6,
    label: "Members/Complete",
  },
  {
    id: 5,
    label: "Step",
  },
]

const Container = styled.div`
  padding: 15px 10px;
  box-shadow: 0 0 2px 0 ${colors.black12};
  background-color: ${colors.white};
  border-radius: 2px;
`

const TeacherKnowmixKnowmeetTable = ({ getRecords }) => {
  const dispatch = useDispatch()
  const history = useHistory()
  const location = useLocation()
  const { path } = useRouteMatch()

  const { errorAlert } = useAlert()

  const { teacherKnowmixKnowmeet } = useSelector(({ knowmap }) => knowmap)

  const [name, setName] = useState("")
  const [page, setPage] = useState(0)
  const [recordsPerPage, setRecordsPerPage] = useState(recordsPerPageOptions[4])

  const [dataReceived, setDataReceived] = useState(false)
  const [changingPage, setChangingPage] = useState(false)

  const _composeQuery = () => {
    composeQuery({
      fields: {
        q: name || undefined,
      },
      history,
      path,
    })
  }

  const onSearch = (event) => {
    event.preventDefault()

    _composeQuery()
  }

  const fetchData = async (offset = 0, shouldPageChange = false) => {
    const { q } = qs.parse(location.search)
    try {
      if (shouldPageChange) setChangingPage(true)

      await getRecords({
        name: q || undefined,
        offset,
        limit: recordsPerPage,
      })

      setDataReceived(true)

      if (shouldPageChange) setChangingPage(false)
    } catch (e) {
      errorAlert(e)
    }
  }

  useEffect(() => {
    const { q } = qs.parse(location.search)

    if (typeof q === "string") {
      setName(q)
    }

    fetchData()

    // fetchRecords()

    return dispatch(clearTeacherKnowmapKnowmixKnowmeets())
  }, [])

  useEffect(() => {
    if (dataReceived) {
      fetchData()
      setPage(0)
    }
  }, [location.search])

  useEffect(() => {
    if (dataReceived && !changingPage) {
      fetchData(teacherKnowmixKnowmeet.availableOffsets[page], true)
    }
  }, [page])

  useEffect(() => {
    if (dataReceived && !changingPage) {
      fetchData()
      setPage(0)
    }
  }, [recordsPerPage])

  const { onFormOpen, onInfoOpen, onDeletionOpen } = useKnowmeetModals()

  return (
    <>
      <div className="box">
        <div className="box__heading">Courses Managed Meets</div>
      </div>

      {dataReceived && (
        <Container>
          <div className="mb15">
            <div className="search-form search-form--compact">
              <div className="search-form__icon">
                <SearchOutlined />
              </div>
              <form onSubmit={onSearch}>
                <input
                  type="text"
                  id="search"
                  name="search"
                  placeholder="Search Knowmeets"
                  className="search-form__field"
                  autoComplete="off"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                />
              </form>
            </div>
          </div>

          <>
            <Table
              columns={columns}
              data={teacherKnowmixKnowmeet.list}
              fluid={columns.length <= 5}
              changingPage={changingPage}
              onDetailsOpen={(record) => onInfoOpen(record.id, "step")}
              actions={(record) => [
                {
                  component: () => (
                    <Tooltip title="Edit" arrow key={key()}>
                      <EditOutlined
                        onClick={() => onFormOpen(record.id, "step")}
                      />
                    </Tooltip>
                  ),
                },
                {
                  component: () => (
                    <Tooltip title="Delete" arrow key={key()}>
                      <DeleteForeverOutlined
                        onClick={() => onDeletionOpen(record.id, "step")}
                      />
                    </Tooltip>
                  ),
                },
              ]}
            />

            <TablePagination
              count={teacherKnowmixKnowmeet.total}
              page={page}
              onPageChange={(e, value) => setPage(value)}
              rowsPerPage={recordsPerPage}
              rowsPerPageOptions={recordsPerPageOptions}
              onRowsPerPageChange={(e) =>
                setRecordsPerPage(parseInt(e.target.value, 10))
              }
            />
          </>
        </Container>
      )}

      <Route
        path={KNOWMAP_INCOMING_KNOWMEET}
        render={() => (
          <UknowDialog
            open
            handleClose={(replace = false) => {
              replace
                ? history.replace(KNOWMAP_UKNOW_KNOWMIX)
                : history.push(KNOWMAP_UKNOW_KNOWMIX)
            }}
            type={"step"}
          />
        )}
      />
    </>
  )
}

const KnowmapTeacherKnowmixKnowmeets = () => {
  const dispatch = useDispatch()

  const getRecords = async ({ name, offset, limit } = {}) => {
    await dispatch(
      getTeacherKnowmapKnowmixKnowmeets({
        name,
        // knowmix_id: knowmixId || parseInt(k),
        limit,
        offset,
      })
    )
  }
  return (
    <KnowmeetModalsProvider updateList={getRecords}>
      <TeacherKnowmixKnowmeetTable getRecords={getRecords} />
    </KnowmeetModalsProvider>
  )
}

export default withErrorBoundary(KnowmapTeacherKnowmixKnowmeets)
